<button (click)="regresarPagina()" style="width: 100px; height: 40px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>

<div class="card">
  <div class="card-body">
  <div style="margin: 25px;">
    <h1>Imágenes del inmueble</h1>
  </div>

<div class="row">
  <div class="col-md-3" *ngFor="let item of imagenesInmueble">
   <div class="col">
    <img [src]="item.url" class="w150" alt="">
    <button (click)="eliminarImagen(item)" class="btn btn-danger">Eliminar</button>
   </div>
  </div>
</div>



<div class="container fileUploadWrapper">
  <form [formGroup]="form">
      <div class="row">
          <!-- Progress Bar -->
          <div class="col-md-12" *ngIf="progress">
              <div class="progress form-group">
                  <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                      [style.width.%]="progress">
                  </div>
              </div>
          </div>


          <div class="col-md-12">
              <div class="fileupload" appSubirimagenes (click)="fileField.click()"
                  (fileDropped)="upload($event)">
                  <span class="ddinfo">Busque o arrástre sus imágenes</span>
                  <input type="file" name="imagen" #fileField (change)="upload($event.target.files)" hidden multiple>
              </div>
          </div>

          <div class="col-md-12">
              <div class="image-list" *ngFor="let file of fileArr; let i = index">
                  <div class="profile">
                      <img [src]="sanitize(file['url'])" alt="">
                  </div>
                    <a class="eliminar" href="javascript:void(0)" (click)="eliminarFoto(file)"><i class="fa fa-trash"></i></a>
              </div>
                <p class="message">{{msg}}</p>
          </div>
            </div>
            <div class="row">
                <button (click)="actualizar()" class="btn btn-block btn-lg btn-info btn-rounded">Guardar</button>
            </div>
  </form>
</div>


<hr>

</div>
</div>



<!-- <div *ngFor="let user of inmuebleObtenido" >
  <div *ngFor="let avatar of user.imagen" >
    <img src="{{avatar}}" alt="">
  </div>
</div>-->

